var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiMedicalSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:medical-symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_434_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4998 5.98633H22.4152C22.5643 5.98633 22.7074 6.04559 22.8129 6.15108C22.9184 6.25657 22.9777 6.39964 22.9777 6.54883C22.9777 7.1207 22.7505 7.66915 22.3461 8.07353C21.9417 8.4779 21.3933 8.70508 20.8214 8.70508H11.4998C11.3029 8.70508 11.1141 8.78331 10.9748 8.92255C10.8356 9.0618 10.7573 9.25065 10.7573 9.44758C10.7573 9.6445 10.8356 9.83336 10.9748 9.9726C11.1141 10.1119 11.3029 10.1901 11.4998 10.1901H18.6052C19.5115 10.1901 20.3806 10.5501 21.0215 11.1909C21.6623 11.8318 22.0223 12.701 22.0223 13.6073C22.0223 14.5136 21.6623 15.3827 21.0215 16.0236C20.3806 16.6644 19.5115 17.0245 18.6052 17.0245H13.3833C13.1959 17.0245 13.0163 17.0989 12.8838 17.2314C12.7513 17.3638 12.6769 17.5435 12.6769 17.7309C12.6769 17.9182 12.7513 18.0979 12.8838 18.2304C13.0163 18.3628 13.1959 18.4373 13.3833 18.4373H17.5205C17.9779 18.4297 18.4322 18.5133 18.857 18.6831C19.2818 18.853 19.6685 19.1056 19.9947 19.4264C20.3208 19.7472 20.5798 20.1298 20.7566 20.5517C20.9334 20.9736 21.0245 21.4265 21.0245 21.884C21.0245 22.3415 20.9334 22.7944 20.7566 23.2163C20.5798 23.6382 20.3208 24.0207 19.9947 24.3415C19.6685 24.6623 19.2818 24.915 18.857 25.0848C18.4322 25.2547 17.9779 25.3382 17.5205 25.3307H12.6305C12.4689 25.3307 12.3139 25.2665 12.1996 25.1522C12.0853 25.0379 12.0211 24.8829 12.0211 24.7213V24.487C12.0211 23.9897 12.2186 23.5128 12.5703 23.1611C12.9219 22.8095 13.3988 22.612 13.8961 22.612H17.5214C17.71 22.6052 17.8885 22.5255 18.0195 22.3897C18.1505 22.254 18.2237 22.0727 18.2237 21.884C18.2237 21.6953 18.1505 21.514 18.0195 21.3782C17.8885 21.2424 17.71 21.1628 17.5214 21.156H13.3833C12.475 21.156 11.6039 20.7952 10.9617 20.1529C10.3194 19.5107 9.95859 18.6396 9.95859 17.7313C9.95859 16.823 10.3194 15.952 10.9617 15.3097C11.6039 14.6675 12.475 14.3066 13.3833 14.3066H18.6052C18.7904 14.3066 18.968 14.2331 19.099 14.1021C19.23 13.9711 19.3036 13.7934 19.3036 13.6082C19.3036 13.423 19.23 13.2453 19.099 13.1143C18.968 12.9834 18.7904 12.9098 18.6052 12.9098H11.5008C11.0462 12.9098 10.596 12.8202 10.176 12.6463C9.75604 12.4723 9.37443 12.2173 9.05298 11.8959C8.73153 11.5744 8.47654 11.1928 8.30257 10.7728C8.1286 10.3528 8.03906 9.90265 8.03906 9.44805C8.03906 8.99345 8.1286 8.5433 8.30257 8.1233C8.47654 7.70331 8.73153 7.32169 9.05298 7.00024C9.37443 6.67879 9.75604 6.4238 10.176 6.24984C10.596 6.07587 11.0452 5.98633 11.4998 5.98633Z",
    fill: "url(#paint0_linear_434_3437)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_434_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5723 7.3457H11.4538C10.9051 7.3457 10.3788 7.56369 9.99078 7.95172C9.60275 8.33974 9.38477 8.86602 9.38477 9.41477C9.38477 10.5566 10.311 11.4829 11.4538 11.4829H18.6238C19.1609 11.4829 19.676 11.6962 20.0557 12.076C20.4355 12.4558 20.6488 12.9708 20.6488 13.5079C20.649 13.7739 20.5967 14.0373 20.495 14.2831C20.3932 14.5289 20.2441 14.7522 20.0561 14.9404C19.868 15.1285 19.6447 15.2778 19.399 15.3796C19.1532 15.4814 18.8898 15.5338 18.6238 15.5338H13.3363C12.2141 15.5338 11.3038 16.4432 11.3038 17.5663C11.3038 18.6895 12.2132 19.5988 13.3363 19.5988H17.541C18.6754 19.5988 19.5941 20.5195 19.5941 21.6538C19.5943 21.9235 19.5412 22.1906 19.4381 22.4398C19.335 22.689 19.1838 22.9155 18.9931 23.1062C18.8025 23.297 18.5761 23.4483 18.3269 23.5515C18.0778 23.6548 17.8107 23.7079 17.541 23.7079H13.9551",
    stroke: "url(#paint1_linear_434_3437)",
    strokeWidth: 0.703125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.1015 7.40951C21.3743 7.40951 21.5955 7.18831 21.5955 6.91545C21.5955 6.64259 21.3743 6.42139 21.1015 6.42139C20.8286 6.42139 20.6074 6.64259 20.6074 6.91545C20.6074 7.18831 20.8286 7.40951 21.1015 7.40951Z",
    fill: "url(#paint2_radial_434_3437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_ii_434_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.4711 1.9917C14.4849 1.9917 13.6946 2.80732 13.7255 3.79264L13.7958 5.98639H17.1464L17.2149 3.79264C17.2223 3.55894 17.1827 3.32614 17.0984 3.10805C17.0141 2.88996 16.8868 2.69103 16.7242 2.52305C16.5616 2.35508 16.3668 2.22149 16.1516 2.13021C15.9363 2.03894 15.7049 1.99183 15.4711 1.9917ZM17.0611 8.70045H13.883L14.0611 14.3011H16.8849L17.0611 8.70045ZM14.3274 22.6167L14.1492 17.0161H16.7995L16.6233 22.6167H14.3283H14.3274ZM14.4146 25.3308L14.4717 27.1214C14.4717 27.3879 14.5776 27.6436 14.7661 27.832C14.9546 28.0205 15.2102 28.1264 15.4767 28.1264C15.7433 28.1264 15.9989 28.0205 16.1874 27.832C16.3759 27.6436 16.4817 27.3879 16.4817 27.1214L16.538 25.3308H14.4146Z",
    fill: "#619AEF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_434_3437",
    x: 8.03906,
    y: 5.75195,
    width: 14.9395,
    height: 19.5791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.411765 0 0 0 0 0.854902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3437"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_434_3437",
    x: 8.33008,
    y: 6.29102,
    width: 14.2969,
    height: 18.4717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562,
    result: "effect1_foregroundBlur_434_3437"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_434_3437",
    x: 13.6309,
    y: 1.9917,
    width: 4.99023,
    height: 26.1348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.40625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.447059 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3437"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.447059 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3437",
    result: "effect2_innerShadow_434_3437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3437",
    x1: 15.5077,
    y1: 5.98633,
    x2: 15.5077,
    y2: 25.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#429AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#277BE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_3437",
    x1: 15.4785,
    y1: 7.3457,
    x2: 15.4785,
    y2: 23.7079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D9BF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_434_3437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.868 7.02326) rotate(-21.913) scale(0.785023 0.903031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#D2C6DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiMedicalSymbol);
export default __webpack_public_path__ + "static/media/fluent-emoji_medical-symbol.e7d586edb6a4c0d6da73de729203315c.svg";
export { ForwardRef as ReactComponent };